export default (title) => {
  let new_title = "";
  if (title !== process.env.VUE_APP_TITLE) {
    new_title += process.env.VUE_APP_TITLE + " | ";
  }
  new_title += title;
  return new_title;
};
